import React, { Fragment } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function Input_Measurement_Print(props) {
  const { label, value, ...rest } = props;
  return (
    <Fragment>
      <div className="form-control-customed single_input">
        <div>
          <Field className="single_input_text" name={label} value={value} />
        </div>
      </div>
    </Fragment>
  );
}

export default Input_Measurement_Print;
